import { render, staticRenderFns } from "./RealEstateEdit.vue?vue&type=template&id=c8cb8896&scoped=true&"
import script from "./RealEstateEdit.vue?vue&type=script&lang=js&"
export * from "./RealEstateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cb8896",
  null
  
)

export default component.exports